export const GLOBAL_ROOM = "global";

export const RTL_LOCALES = ["ar"];
